export const STEPS = [
  {
    id: "channels",
    title: "Notifications",
    blurb: "Choose how staff are contacted.",
  },
  {
    id: "policy",
    title: "Coverage path",
    blurb: "Name the path you’re setting up.",
  },
  {
    id: "tiers",
    title: "Staff & timing",
    blurb: "Who is contacted, and how long to wait.",
  },
  {
    id: "notify",
    title: "Contacts",
    blurb: "Add people or numbers for each step.",
  },
  {
    id: "types",
    title: "Requests",
    blurb: "Match each patient request to a path.",
  },
  {
    id: "tenant",
    title: "Defaults",
    blurb: "Wake phrase and everyday settings.",
  },
  {
    id: "agent",
    title: "Voice assistant",
    blurb: "Default agent, plus org / site / location overrides.",
  },
  { id: "review", title: "Finish", blurb: "Review" },
] as const;

export type StepId = (typeof STEPS)[number]["id"];

/** Groups that share one save action. Moving inside a group does not count as leaving it. */
export type SaveGroup = "policy" | "requests" | "defaults";

export function saveGroupForStep(id: StepId): SaveGroup | null {
  if (id === "policy" || id === "tiers" || id === "notify") return "policy";
  if (id === "types") return "requests";
  if (id === "tenant") return "defaults";
  return null;
}

export const CHANNEL_LABELS: Record<string, string> = {
  EMAIL: "Email",
  SMS: "Text message",
  APP: "Staff app",
  API: "Care system alert",
};
